const APPCONFIG = {
    ENDPOINTS: {
        SECURITYURL: process.env.REACT_APP_SECURITYURL,
        PRODUCERURL: process.env.REACT_APP_PRODUCERURL,
    },
    FOOTER: {
        ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
        VERSION: process.env.REACT_APP_VERSION,
        PORTAL: 'Portal de Empresas',
        BUTTON_TEXT: 'Soporte técnico',
    },
    URLS: {
        EBROKERLINK: process.env.REACT_APP_EBROKERLINK,
  },
    ENABLESCHEDULER: process.env.REACT_APP_ENABLESCHEDULER
}
export { APPCONFIG };